export const PopularCities = [
  {
    cityId: 6772,
    cityName: "Pune",
    stateName: "Maharashtra",
    suggestionType: "CITY",
  },
  {
    cityId: 4742,
    cityName: "Delhi",
    stateName: "Delhi",
    suggestionType: "CITY",
  },
  {
    cityId: 4292,
    cityName: "Bengaluru",
    stateName: "Karnataka",
    suggestionType: "CITY",
  },
  {
    cityId: 4517,
    cityName: "Chandigarh",
    stateName: "Punjab",
    suggestionType: "CITY",
  },
  {
    cityId: 5262,
    cityName: "Jaipur, Rajasthan",
    stateName: "Rajasthan",
    suggestionType: "CITY",
  },
  {
    cityId: 5230,
    cityName: "Indore",
    stateName: "Madhya Pradesh",
    suggestionType: "CITY",
  },
  {
    cityId: 3905,
    cityName: "Ahmedabad",
    stateName: "Gujarat",
    suggestionType: "CITY",
  },
  {
    cityId: 5215,
    cityName: "Hyderabad",
    stateName: "Telangana",
    suggestionType: "CITY",
  },
  {
    cityId: 6244,
    cityName: "Mumbai",
    stateName: "Maharashtra",
    suggestionType: "CITY",
  },
  {
    cityId: 4562,
    cityName: "Chennai",
    stateName: "Tamil Nadu",
    suggestionType: "CITY",
  },
];
